module.exports = __webpack_public_path__ + "static/img/24.6960159.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/24.jpg
// module id = T1QE
// module chunks = 1